module.exports = __webpack_public_path__ + "static/img/son4_active.a4029655.png";